import React, { useState, useEffect , useRef} from 'react';
import { connect } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col, Label } from 'reactstrap';
import { AvFeedback, AvForm, AvGroup, AvInput, AvField } from 'availity-reactstrap-validation';
import { Translate, translate, ICrudGetAction, ICrudGetAllAction, setFileData, byteSize, ICrudPutAction } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IRootState } from 'app/shared/reducers';

import { getEntity, updateEntity, createEntity, setBlob, reset } from './zixun.reducer';
import { IZixun } from 'app/shared/model/zixun.model';
import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';


export interface IZixunUpdateProps extends StateProps, DispatchProps, RouteComponentProps<{ id: string }> {}

export const ZixunUpdate = (props: IZixunUpdateProps) => {
  const [isNew, setIsNew] = useState(!props.match.params || !props.match.params.id);

  const { zixunEntity, loading, updating } = props;

  const { content } = zixunEntity;



  const handleClose = () => {
    props.history.push('/zixun');
  };

  useEffect(() => {
    if (isNew) {
      props.reset();
    } else {
      props.getEntity(props.match.params.id);
    }
  }, []);

  const onBlobChange = (isAnImage, name) => event => {
    setFileData(event, (contentType, data) => props.setBlob(name, data, contentType), isAnImage);
  };

  const clearBlob = name => () => {
    props.setBlob(name, undefined, undefined);
  };

  useEffect(() => {
    if (props.updateSuccess) {
      handleClose();
    }
  }, [props.updateSuccess]);

  const mycontent = useRef(null);

  const saveEntity = (event, errors, values) => {
    if (errors.length === 0) {

      const entity = {

        ...zixunEntity,
        "content":mycontent.current.innerHTML,
        ...values,
      };


      if (isNew) {
        props.createEntity(entity);
      } else {
        props.updateEntity(entity);
      }
    }
  };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="examsysApp.zixun.home.createOrEditLabel">
            <Translate contentKey="examsysApp.zixun.home.createOrEditLabel">Create or edit a Zixun</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <AvForm model={isNew ? {} : zixunEntity} onSubmit={saveEntity}>
              {!isNew ? (
                <AvGroup>
                  <Label for="zixun-id">
                    <Translate contentKey="global.field.id">ID</Translate>
                  </Label>
                  <AvInput id="zixun-id" type="text" className="form-control" name="id" required readOnly />
                </AvGroup>
              ) : null}
              <AvGroup>
                <Label id="titleLabel" for="zixun-title">
                  <Translate contentKey="examsysApp.zixun.title">Title</Translate>
                </Label>
                <AvField
                  id="zixun-title"
                  type="text"
                  name="title"
                  validate={{
                    required: { value: true, errorMessage: translate('entity.validation.required') },
                  }}
                />
              </AvGroup>
              <AvGroup>
                <Label id="timeLabel" for="zixun-time">
                  <Translate contentKey="examsysApp.zixun.time">Time</Translate>
                </Label>
                <AvField
                  id="zixun-time"
                  type="text"
                  name="time"
                  validate={{
                    required: { value: true, errorMessage: translate('entity.validation.required') },
                  }}
                />
              </AvGroup>
              <AvGroup check>
                <Label id="isTopLabel">
                  <AvInput id="zixun-isTop" type="checkbox" className="form-check-input" name="isTop" />
                  <Translate contentKey="examsysApp.zixun.isTop">Is Top</Translate>
                </Label>
              </AvGroup>
              <AvGroup>
                <Label id="authorLabel" for="zixun-author">
                  <Translate contentKey="examsysApp.zixun.author">Author</Translate>
                </Label>
                <AvField
                  id="zixun-author"
                  type="text"
                  name="author"
                  validate={{
                    required: { value: true, errorMessage: translate('entity.validation.required') },
                  }}
                />
              </AvGroup>
              <AvGroup>
                <Label id="contentLabel" for="zixun-content">
                  <Translate contentKey="examsysApp.zixun.content">Content</Translate>
                </Label>

                <div
                  ref={mycontent}
                contentEditable={true}
                  dangerouslySetInnerHTML={{__html:content}}
                  style={{"padding":"10px","overflow":"auto","width":"100%","height":"300px","border":"1px solid #ccc"}}>

                </div>

              </AvGroup>
              <Button tag={Link} id="cancel-save" to="/zixun" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </AvForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

const mapStateToProps = (storeState: IRootState) => ({
  zixunEntity: storeState.zixun.entity,
  loading: storeState.zixun.loading,
  updating: storeState.zixun.updating,
  updateSuccess: storeState.zixun.updateSuccess,
});

const mapDispatchToProps = {
  getEntity,
  updateEntity,
  setBlob,
  createEntity,
  reset,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(ZixunUpdate);
